import { money } from "@/lib/api";
const fmt = (d) => new Date(d).toLocaleString("pt-BR");
const addr = (c) => [c.logradouro, c.numero, c.bairro, c.cidade, c.estado].filter(Boolean).join(", ");

export function PrintEntry({ os, client, settings }) {
  return (
    <div style={{ padding: 32, fontFamily: "Arial, sans-serif", color: "#000", background: "#fff", maxWidth: 800 }}>
      <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "3px solid #D4AF37", paddingBottom: 16 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24 }}>{settings.company_name || "Alpha Prime"}</h1>
          <p style={{ margin: "4px 0", fontSize: 12, color: "#555" }}>{settings.os_entry_header}</p>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 22, fontWeight: "bold" }}>{os.number}</div>
          <div style={{ fontSize: 12 }}>{fmt(os.createdAt)}</div>
          <div style={{ fontSize: 16, fontWeight: "bold", color: "#AA820A" }}>Retirada: {os.withdrawalCode}</div>
        </div>
      </div>
      <table style={{ width: "100%", marginTop: 18, fontSize: 13 }}><tbody>
        <tr><td style={l}>Cliente</td><td style={c}>{os.customerName}</td><td style={l}>Telefone</td><td style={c}>{os.customerPhone || "—"}</td></tr>
        <tr><td style={l}>CPF</td><td style={c}>{client.cpf || "—"}</td><td style={l}>E-mail</td><td style={c}>{client.email || "—"}</td></tr>
        <tr><td style={l}>Endereço</td><td style={c} colSpan={3}>{addr(client) || "—"}</td></tr>
        <tr><td style={l}>Aparelho</td><td style={c}>{os.device?.brand} {os.device?.model}</td><td style={l}>Cor</td><td style={c}>{os.device?.color || "—"}</td></tr>
        <tr><td style={l}>IMEI</td><td style={c} colSpan={3}>{os.device?.imei || "—"}</td></tr>
      </tbody></table>
      <h3 style={{ marginTop: 16, borderBottom: "1px solid #ccc" }}>Defeito Relatado</h3>
      <p style={{ fontSize: 13 }}>{os.reportedIssue}</p>
      {settings.os_entry_terms && (<><h3 style={{ borderBottom: "1px solid #ccc" }}>Termos</h3><p style={{ fontSize: 11, color: "#444" }}>{settings.os_entry_terms}</p></>)}
      {settings.os_entry_observations && <p style={{ fontSize: 11, color: "#666", marginTop: 8 }}>{settings.os_entry_observations}</p>}
      <div style={{ marginTop: 12, fontSize: 12, borderTop: "1px dashed #ccc", paddingTop: 8 }}>Observações: ____________________________________________________________</div>
      <div style={{ marginTop: 50, textAlign: "center", fontSize: 12 }}>
        <div style={{ borderTop: "1px solid #000", width: "60%", margin: "0 auto", paddingTop: 4 }}>Assinatura do Cliente</div>
      </div>
      <p style={{ marginTop: 20, fontSize: 11, color: "#666", textAlign: "center" }}>{settings.os_entry_footer}</p>
    </div>
  );
}

export function PrintExit({ os, client, settings }) {
  return (
    <div style={{ padding: 32, fontFamily: "Arial, sans-serif", color: "#000", background: "#fff", maxWidth: 800 }}>
      <div style={{ display: "flex", justifyContent: "space-between", borderBottom: "3px solid #D4AF37", paddingBottom: 16 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 24 }}>{settings.company_name || "Alpha Prime"}</h1>
          <p style={{ margin: "4px 0", fontSize: 12, color: "#555" }}>Comprovante de Saída / Retirada</p>
        </div>
        <div style={{ textAlign: "right" }}><div style={{ fontSize: 22, fontWeight: "bold" }}>{os.number}</div><div style={{ fontSize: 12 }}>{fmt(os.updatedAt)}</div></div>
      </div>
      <table style={{ width: "100%", marginTop: 18, fontSize: 13 }}><tbody>
        <tr><td style={l}>Cliente</td><td style={c}>{os.customerName}</td><td style={l}>Telefone</td><td style={c}>{os.customerPhone || "—"}</td></tr>
        <tr><td style={l}>Aparelho</td><td style={c}>{os.device?.brand} {os.device?.model}</td><td style={l}>IMEI</td><td style={c}>{os.device?.imei || "—"}</td></tr>
      </tbody></table>
      <h3 style={{ marginTop: 16, borderBottom: "1px solid #ccc" }}>Serviço Realizado</h3>
      <p style={{ fontSize: 13 }}>{os.performedRepair || os.reportedIssue}</p>
      <table style={{ width: "100%", marginTop: 12, fontSize: 15 }}><tbody>
        <tr style={{ fontWeight: "bold", fontSize: 18 }}><td>VALOR</td><td style={{ textAlign: "right" }}>{money(os.chargedAmount)}</td></tr>
      </tbody></table>
      <h3 style={{ marginTop: 16, borderBottom: "1px solid #ccc" }}>Garantia</h3>
      <p style={{ fontSize: 12 }}>{settings.os_exit_warranty}</p>
      {settings.os_exit_observations && <p style={{ fontSize: 11, color: "#666" }}>{settings.os_exit_observations}</p>}
      <div style={{ marginTop: 50, textAlign: "center", fontSize: 12 }}>
        <div style={{ borderTop: "1px solid #000", width: "60%", margin: "0 auto", paddingTop: 4 }}>Assinatura do Cliente</div>
      </div>
      <p style={{ marginTop: 20, fontSize: 11, color: "#666", textAlign: "center" }}>{settings.os_exit_footer}</p>
    </div>
  );
}

const l = { fontWeight: "bold", padding: "4px 8px", background: "#f5f5f5", width: 110 };
const c = { padding: "4px 8px" };

export function PdvReceipt({ sale, settings }) {
  return (
    <div style={{ width: 300, fontFamily: "monospace", color: "#000", background: "#fff", padding: 10, fontSize: 12 }}>
      <div style={{ textAlign: "center" }}>
        <strong style={{ fontSize: 15 }}>{settings.company_name || "Alpha Prime"}</strong>
        <div style={{ fontSize: 10 }}>{settings.pdv_receipt_header}</div>
        {settings.company_cnpj && <div style={{ fontSize: 10 }}>CNPJ: {settings.company_cnpj}</div>}
        {settings.company_address && <div style={{ fontSize: 10 }}>{settings.company_address}</div>}
        {settings.company_phone && <div style={{ fontSize: 10 }}>Tel: {settings.company_phone}</div>}
      </div>
      <div style={{ borderTop: "1px dashed #000", margin: "8px 0" }} />
      <div><strong>{sale.saleNumber}</strong></div>
      <div>{new Date(sale.createdAt).toLocaleString("pt-BR")}</div>
      {sale.customerName && <div>Cliente: {sale.customerName}</div>}
      <div style={{ borderTop: "1px dashed #000", margin: "8px 0" }} />
      {sale.serviceOrderNumber && (
        <div style={{ display: "flex", justifyContent: "space-between" }}><span>Serviço {sale.serviceOrderNumber}</span><span>{fmtMoney(sale.serviceValue)}</span></div>
      )}
      {(sale.items || []).map((it, i) => (
        <div key={it.inventoryId || it.sku || i}>
          <div style={{ display: "flex", justifyContent: "space-between" }}><span>{it.qty}x {it.name}</span><span>{fmtMoney(it.price * it.qty)}</span></div>
          {it.kind === "device" && it.imei && <div style={{ fontSize: 10, color: "#333" }}>IMEI: {it.imei}</div>}
        </div>
      ))}
      <div style={{ borderTop: "1px dashed #000", margin: "8px 0" }} />
      {sale.discount > 0 && (
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}><span>Subtotal</span><span>{fmtMoney(sale.subtotal ?? (sale.total + sale.discount))}</span></div>
          <div style={{ display: "flex", justifyContent: "space-between" }}><span>Desconto</span><span>- {fmtMoney(sale.discount)}</span></div>
        </>
      )}
      <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", fontSize: 14 }}><span>TOTAL</span><span>{fmtMoney(sale.total)}</span></div>
      <div>Pagamento: {sale.paymentMethod}</div>
      {settings.pdv_receipt_observations && <div style={{ fontSize: 10, marginTop: 8 }}>{settings.pdv_receipt_observations}</div>}
      <div style={{ borderTop: "1px dashed #000", margin: "8px 0" }} />
      <div style={{ textAlign: "center", fontSize: 10 }}>{settings.pdv_receipt_footer}</div>
    </div>
  );
}
const fmtMoney = (v) => money(v);
